import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../src/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_0bf314d6 from 'nuxt_plugin_plugin_0bf314d6' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_2d05be79 from 'nuxt_plugin_plugin_2d05be79' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_plugin_567faabd from 'nuxt_plugin_plugin_567faabd' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_gtm_e099247e from 'nuxt_plugin_gtm_e099247e' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_pluginutils_0165d170 from 'nuxt_plugin_pluginutils_0165d170' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_15907a8a from 'nuxt_plugin_pluginrouting_15907a8a' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_40af9a94 from 'nuxt_plugin_pluginmain_40af9a94' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_pluginserver_c1c4097a from 'nuxt_plugin_pluginserver_c1c4097a' // Source: ./plugin.server.js (mode: 'server')
import nuxt_plugin_workbox_7cafae87 from 'nuxt_plugin_workbox_7cafae87' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_5add02cc from 'nuxt_plugin_metaplugin_5add02cc' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_518db7e4 from 'nuxt_plugin_iconplugin_518db7e4' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_3212fc5a from 'nuxt_plugin_cookieuniversalnuxt_3212fc5a' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_axios_5cb6cfaa from 'nuxt_plugin_axios_5cb6cfaa' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_distplugin2d534ee1_432fe972 from 'nuxt_plugin_distplugin2d534ee1_432fe972' // Source: ./dist.plugin.2d534ee1.mjs (mode: 'all')
import nuxt_plugin_config_25e1f236 from 'nuxt_plugin_config_25e1f236' // Source: ../src/plugins/config (mode: 'all')
import nuxt_plugin_axios_2228ef02 from 'nuxt_plugin_axios_2228ef02' // Source: ../src/plugins/axios (mode: 'all')
import nuxt_plugin_amplitude_362605fc from 'nuxt_plugin_amplitude_362605fc' // Source: ../src/plugins/amplitude.server (mode: 'server')
import nuxt_plugin_datadog_87595b5a from 'nuxt_plugin_datadog_87595b5a' // Source: ../src/plugins/datadog.server (mode: 'server')
import nuxt_plugin_datadog_bd37d24a from 'nuxt_plugin_datadog_bd37d24a' // Source: ../src/plugins/datadog.client (mode: 'client')
import nuxt_plugin_featuredetection_5064dcfa from 'nuxt_plugin_featuredetection_5064dcfa' // Source: ../src/plugins/feature-detection (mode: 'all')
import nuxt_plugin_gtm_caeab2a8 from 'nuxt_plugin_gtm_caeab2a8' // Source: ../src/plugins/gtm (mode: 'all')
import nuxt_plugin_linkservice_706db054 from 'nuxt_plugin_linkservice_706db054' // Source: ../src/plugins/link-service (mode: 'all')
import nuxt_plugin_meta_92669c0e from 'nuxt_plugin_meta_92669c0e' // Source: ../src/plugins/meta (mode: 'all')
import nuxt_plugin_testid_08e1bfc2 from 'nuxt_plugin_testid_08e1bfc2' // Source: ../src/plugins/test-id (mode: 'all')
import nuxt_plugin_gettext_593fa90f from 'nuxt_plugin_gettext_593fa90f' // Source: ../src/plugins/gettext (mode: 'all')
import nuxt_plugin_pinia_22f58ff9 from 'nuxt_plugin_pinia_22f58ff9' // Source: ../src/plugins/pinia (mode: 'all')
import nuxt_plugin_auth_2b85dfa5 from 'nuxt_plugin_auth_2b85dfa5' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_branch_6a3c5fba from 'nuxt_plugin_branch_6a3c5fba' // Source: ../src/plugins/branch.client (mode: 'client')
import nuxt_plugin_amplitude_6c047cec from 'nuxt_plugin_amplitude_6c047cec' // Source: ../src/plugins/amplitude.client (mode: 'client')
import nuxt_plugin_experiments_16626da2 from 'nuxt_plugin_experiments_16626da2' // Source: ../src/plugins/experiments (mode: 'all')
import nuxt_plugin_user_925ef082 from 'nuxt_plugin_user_925ef082' // Source: ../src/plugins/user (mode: 'all')
import nuxt_plugin_search_409cd49c from 'nuxt_plugin_search_409cd49c' // Source: ../src/plugins/search (mode: 'all')
import nuxt_plugin_braze_729a60f1 from 'nuxt_plugin_braze_729a60f1' // Source: ../src/plugins/braze.client (mode: 'client')
import nuxt_plugin_snowplow_b7649384 from 'nuxt_plugin_snowplow_b7649384' // Source: ../src/plugins/snowplow.client (mode: 'client')
import nuxt_plugin_meta_24dd110f from 'nuxt_plugin_meta_24dd110f' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":"%s | LTK","title":"LTK","meta":[{"hid":"charset","charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Shop Your Screenshots™ with LTK, a shopping discovery app that allows you to instantly shop your favorite influencer pics across social media and the mobile web."},{"name":"referrer","content":"always"},{"name":"color-scheme","content":"light"},{"name":"application-name","content":"LTK"},{"name":"msapplication-TileColor","content":"#FFFFFF"},{"name":"msapplication-TileImage","content":"\u002Ffavicon-144.png?v=4"},{"hid":"og:title","property":"og:title","content":"LTK","template":(s) => `${s} | LTK`}],"link":[{"rel":"icon","type":"image\u002Fpng","href":"\u002Ffavicon.png?v=4","sizes":"32x32"},{"rel":"icon","type":"image\u002Fpng","href":"\u002Ffavicon-128.png?v=4","sizes":"128x128"},{"rel":"icon","type":"image\u002Fpng","href":"\u002Ffavicon-192.png?v=4","sizes":"192x192"},{"rel":"shortcut icon","type":"image\u002Fpng","href":"\u002Ffavicon-196.png?v=4","sizes":"196x196"},{"rel":"apple-touch-icon","href":"\u002Ffavicon-152.png?v=4","sizes":"152x152"},{"rel":"apple-touch-icon","href":"\u002Ffavicon-180.png?v=4","sizes":"180x180"},{"hid":"apple-touch-startup-image-iphonexsmax","rel":"apple-touch-startup-image","href":"\u002Fstatic\u002Ficons\u002Fsplash_iphonexsmax_1242x2688.6b17fa.png","media":"(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3)"},{"hid":"apple-touch-startup-image-iphonexr","rel":"apple-touch-startup-image","href":"\u002Fstatic\u002Ficons\u002Fsplash_iphonexr_828x1792.6b17fa.png","media":"(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2)"},{"hid":"apple-touch-startup-image-iphonex","rel":"apple-touch-startup-image","href":"\u002Fstatic\u002Ficons\u002Fsplash_iphonex_1125x2436.6b17fa.png","media":"(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3)"},{"hid":"apple-touch-startup-image-iphoneplus","rel":"apple-touch-startup-image","href":"\u002Fstatic\u002Ficons\u002Fsplash_iphoneplus_1242x2208.6b17fa.png","media":"(device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3)"},{"hid":"apple-touch-startup-image-iphone6","rel":"apple-touch-startup-image","href":"\u002Fstatic\u002Ficons\u002Fsplash_iphone6_750x1334.6b17fa.png","media":"(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2)"},{"hid":"apple-touch-startup-image-iphone5","rel":"apple-touch-startup-image","href":"\u002Fstatic\u002Ficons\u002Fsplash_iphone5_640x1136.6b17fa.png","media":"(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2)"}],"style":[],"script":[{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);}})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":""}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_0bf314d6 === 'function') {
    await nuxt_plugin_plugin_0bf314d6(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_2d05be79 === 'function') {
    await nuxt_plugin_plugin_2d05be79(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_567faabd === 'function') {
    await nuxt_plugin_plugin_567faabd(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_e099247e === 'function') {
    await nuxt_plugin_gtm_e099247e(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_0165d170 === 'function') {
    await nuxt_plugin_pluginutils_0165d170(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_15907a8a === 'function') {
    await nuxt_plugin_pluginrouting_15907a8a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_40af9a94 === 'function') {
    await nuxt_plugin_pluginmain_40af9a94(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_pluginserver_c1c4097a === 'function') {
    await nuxt_plugin_pluginserver_c1c4097a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_7cafae87 === 'function') {
    await nuxt_plugin_workbox_7cafae87(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_5add02cc === 'function') {
    await nuxt_plugin_metaplugin_5add02cc(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_518db7e4 === 'function') {
    await nuxt_plugin_iconplugin_518db7e4(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_3212fc5a === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_3212fc5a(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5cb6cfaa === 'function') {
    await nuxt_plugin_axios_5cb6cfaa(app.context, inject)
  }

  if (typeof nuxt_plugin_distplugin2d534ee1_432fe972 === 'function') {
    await nuxt_plugin_distplugin2d534ee1_432fe972(app.context, inject)
  }

  if (typeof nuxt_plugin_config_25e1f236 === 'function') {
    await nuxt_plugin_config_25e1f236(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2228ef02 === 'function') {
    await nuxt_plugin_axios_2228ef02(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_amplitude_362605fc === 'function') {
    await nuxt_plugin_amplitude_362605fc(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_datadog_87595b5a === 'function') {
    await nuxt_plugin_datadog_87595b5a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_datadog_bd37d24a === 'function') {
    await nuxt_plugin_datadog_bd37d24a(app.context, inject)
  }

  if (typeof nuxt_plugin_featuredetection_5064dcfa === 'function') {
    await nuxt_plugin_featuredetection_5064dcfa(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_caeab2a8 === 'function') {
    await nuxt_plugin_gtm_caeab2a8(app.context, inject)
  }

  if (typeof nuxt_plugin_linkservice_706db054 === 'function') {
    await nuxt_plugin_linkservice_706db054(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_92669c0e === 'function') {
    await nuxt_plugin_meta_92669c0e(app.context, inject)
  }

  if (typeof nuxt_plugin_testid_08e1bfc2 === 'function') {
    await nuxt_plugin_testid_08e1bfc2(app.context, inject)
  }

  if (typeof nuxt_plugin_gettext_593fa90f === 'function') {
    await nuxt_plugin_gettext_593fa90f(app.context, inject)
  }

  if (typeof nuxt_plugin_pinia_22f58ff9 === 'function') {
    await nuxt_plugin_pinia_22f58ff9(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_2b85dfa5 === 'function') {
    await nuxt_plugin_auth_2b85dfa5(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_branch_6a3c5fba === 'function') {
    await nuxt_plugin_branch_6a3c5fba(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_amplitude_6c047cec === 'function') {
    await nuxt_plugin_amplitude_6c047cec(app.context, inject)
  }

  if (typeof nuxt_plugin_experiments_16626da2 === 'function') {
    await nuxt_plugin_experiments_16626da2(app.context, inject)
  }

  if (typeof nuxt_plugin_user_925ef082 === 'function') {
    await nuxt_plugin_user_925ef082(app.context, inject)
  }

  if (typeof nuxt_plugin_search_409cd49c === 'function') {
    await nuxt_plugin_search_409cd49c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_braze_729a60f1 === 'function') {
    await nuxt_plugin_braze_729a60f1(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_snowplow_b7649384 === 'function') {
    await nuxt_plugin_snowplow_b7649384(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_24dd110f === 'function') {
    await nuxt_plugin_meta_24dd110f(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
